import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { HelperService } from 'app/services';

@Component({
  selector: 'app-tire-cart',
  templateUrl: './tire-cart.component.html',
  styleUrls: ['./tire-cart.component.scss'],
})
export class TireCartComponent implements OnInit {
  @Input() cartitemList: any = [];
  @Input() source: string = '';
  @Input() cartSummary = {
    total: 0,
    shippingCost: 0,
    grand: 0,
    count: 0,
    totalPrice: 0,
    grandPrice: 0,
  };
  @Input() shippingLoader = {};
  @Input() isShippingCalculating: boolean = false;
  @Input() isSubmitting: boolean = false;
  @Input() isOpenFromQuickTireLookup: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() hideCost: boolean = false;
  @Input() isOpenFromReplenishment: boolean = false;
  @Output() closeCart = new EventEmitter();
  @Output() appOnFocus = new EventEmitter();
  @Output() appOnBlur = new EventEmitter();
  @Output() appOnTireSelect = new EventEmitter();
  @Output() appOnCountChange = new EventEmitter();
  @Output() appOnOpenSupplierDropDown = new EventEmitter();
  @Output() appOnSave = new EventEmitter();
  @Output() appOnSelectDelivery = new EventEmitter();
  @Output() appOnAddCustomerAndVehicle = new EventEmitter();
  @Output() appOnCreateInvetoryOrder = new EventEmitter();

  usd: string = currency.USD;
  displayDetails = {
    tireconnect: {
      logo: 'assets/img/tireconnect-cart-logo.png',
      alt: 'TireConnect Logo',
      heading: 'Cart - TireConnect',
    },
    tirehub: {
      logo: 'assets/img/Tirehub_Logo.svg',
      alt: 'TireHub Logo',
      heading: 'Cart - TireHub',
    },
    autoleap: {
      logo: 'assets/img/AL_Logo.svg',
      alt: 'AL Inventory Logo',
      heading: 'Cart - AL Inventory',
    },
  };

  constructor(private helperService: HelperService) {}

  ngOnInit(): void {}

  handleCloseCart() {
    this.closeCart.emit(false);
  }

  handleFocus(tireId: string) {
    this.appOnFocus.emit(tireId);
  }

  handleBlur(tireId: string) {
    this.appOnBlur.emit(tireId);
  }

  handleTireSelect(tireId: string, tire: any) {
    this.appOnTireSelect.emit({ tireId: tireId, tire: tire });
  }

  isValidData(item: any, count: number) {
    if ((item?.totalAvailable || item?.countAvailable) < count) {
      item.error = true;
    } else {
      item.error = false;
      return true;
    }
    return false;
  }

  handleValidate() {
    let obj: any = {
      isValid: true
    }
    //let isValid: boolean = true;

    for (const warehouse of this.cartitemList) {
      for (const item of warehouse?.tires) {
        if ((item?.totalAvailable || item?.countAvailable) < item.count) {
          item.error = true;
          obj.isValid = false;
          obj.errorMsgQty = `Qty can't be greater than available qty`;
        } else {
          item.error = false;
        }

        if(this.source === 'tireconnect') {
          const deliveryMethodsAvailable = warehouse?.supplierFields || warehouse?.options;
          if(!warehouse?.delivery?.option?.value && deliveryMethodsAvailable?.length) {
            item.deliveryMethodError = true;
            obj.isValid = false;
            obj.errorMsgDeliveryMtd = `Please select delivery method to proceed`;
          } else {
            item.deliveryMethodError = false;
          }
        }
      }
    }
    return obj;
  }

  handleCountChange(tireId: string, count: number = 0, item: any) {
    item.count = count;
    if (this.isValidData(item, count)) {
      this.appOnCountChange.emit({ tireId, count: count });
    } else {
      this.helperService.showToaster('error', `Qty can't be greater than available qty`);
    }
  }

  getSupplierFields(warehouse: any) {
    if (!warehouse?.supplierFields?.length) {
      this.appOnOpenSupplierDropDown.emit(warehouse);
    }
  }

  getSelectedValue(selectedFields: any, key: string) {
    if (selectedFields && selectedFields[key]) {
      return selectedFields[key];
    }

    return null;
  }

  handleSaveCart() {
    const obj = this.handleValidate();
    if (obj.isValid) {
      this.appOnSave.emit();
    } else {
      this.helperService.showToaster('error', obj?.errorMsgQty || obj?.errorMsgDeliveryMtd);
    }
  }

  handleCreateInvetoryOrder() {
    const obj = this.handleValidate();
    if (obj.isValid) {
      this.appOnCreateInvetoryOrder.emit();
    } else {
      this.helperService.showToaster('error', obj?.errorMsgQty || obj?.errorMsgDeliveryMtd);
    }
  }

  handleAddCustomerAndVehicleCart() {
    const obj = this.handleValidate();
    if (obj.isValid) {
      this.appOnAddCustomerAndVehicle.emit();
    } else {
      this.helperService.showToaster('error', obj?.errorMsgQty || obj?.errorMsgDeliveryMtd);
    }
  }

  handleDeliverSelect(warehouse: any, delivery: any, item: any, supplierField: any) {
    if (item) {
      if (this.isValidData(item, item.count || 0)) {
        if(delivery) {
          item.deliveryMethodError = false;
        }
        this.appOnSelectDelivery.emit({ warehouse, delivery, supplierField });
      } else {
        this.helperService.showToaster('error', `Qty can't be greater than available qty`);
      }
    }
  }
}
